
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class KatalogYeriAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "Kutuphane/KatalogYeri";
        super(baseUrl);
    }


    KatalogYeri() {

        return this.get("");

    }

}
export default new KatalogYeriAPI();
